export function fast<T>(
  file: File,
  url: string,
  data: Dictionary<string | Blob> = {},
  action: 'PUT' | 'POST' = 'POST'
): Promise<T> {
  // if (process.env.NODE_ENV === 'development') {
  //   url = 'http://localhost:5000/files/test';
  //   action = 'POST';
  // }

  const params: string[] = [];
  const form = new FormData();
  _objMap(data, (key: string, value: string | Blob) => {
    if (value && typeof value === 'object' && typeof value.toString !== 'function') {
      if (value instanceof File) {
        form.append(key, value, value.name);
      } else {
        form.append(key, JSON.stringify(value));
      }
    } else {
      form.append(key, value);
      if (typeof value === 'string') {
        params.push([encodeURIComponent(key), encodeURIComponent(value)].join('='));
      }
    }
  });
  form.append('file', file, file.name);
  const xhr = new XMLHttpRequest();
  xhr.open(action, `${url}?${params.join('&')}`);

  return new Promise((resolve, reject) => {
    xhr.onload = () => {
      if (xhr.status < 200 || xhr.status >= 300) {
        return reject(new Error(`Upload failed with status ${xhr.status}`));
      }
      const resp = xhr.responseText;
      if (!resp) {
        return resolve(undefined as unknown as T);
      }
      try {
        resolve(JSON.parse(resp));
      } catch (err) {
        reject(err);
      }
    };
    xhr.onerror = () => reject(new Error('Upload failed: network error'));
    xhr.onabort = () => reject(new Error('Upload aborted'));
    xhr.ontimeout = () => reject(new Error('Upload timed out'));
    xhr.send(form);
  });
}

function _objMap(obj: Dictionary<unknown>, callback: (key: string, value: string | Blob) => void) {
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    if (typeof value === 'string' || value instanceof Blob) {
      callback(key, value);
    }
  });
}
